<div style="z-index: -1; height: 100%">
  <cst-card
    style="z-index: -1"
    [isLoading]="!facilityNoInternal || isLoading"
    [compact]="true"
    headerIcon="event"
    >
    <ng-template cstCardTitle>
      <span i18n="@@ServiceHistory"> Service history </span>
      <span>
        @if (!isConnected) {
          <mat-icon
            matTooltip="Keine Internetverbindung"
            style="margin-left: 50px; color: red"
            aria-hidden="false"
            aria-label="Example home icon"
            >cloud_off</mat-icon
            >
          }
        </span>
      </ng-template>
      <ng-template cstCardContent>
        <div style="display: flex; flex-direction: column; height: 100%">
          @if (displayFilter) {
            <div>
              <mat-chip-set>
                @for (filter of filtersCombined; track $index) {
                  <mat-chip
                    [removable]="filter.onRemove"
                    (removed)="filter.onRemove()"
                    [attr.title]="filter.tooltip ? filter.tooltip : null"
                    >
                    {{ filter.label }}
                    @if (filter.onRemove) {
                      <mat-icon matChipRemove>cancel</mat-icon>
                    }
                  </mat-chip>
                }
              </mat-chip-set>
            </div>
          }
          @if (displayFilter) {
            <div></div>
          }
          <div
          style="
            font-size: smaller;
            padding-right: 10px;
            margin-left: 10px;
            margin-top: 10px;
            flex-grow: 1;
            overflow-y: auto;
          "
            >
            @if (dataFromBackend?.data?.length > 0) {
              <app-timeline
                [timelineEvents]="dataFromBackend.data"
                [displaySideElement]="true"
                [expandEntriesEnabled]="true"
                [alwaysOpen]="false"
                >
                <ng-template cstTimelineHeader let-event="event">
                  <div
                  style="
                    text-align: left;
                    font-weight: bold;
                    font-size: smaller;
                  "
                    [class]="event.rawData.archived ? 'archived' : null"
                    >
                    @if (event.entryType !== 2) {
                      <mat-icon
                        style="vertical-align: middle"
                        >
                        @if (event.entryType === 4) {
                          <span class="material-icons-round mat-icons">
                            note
                          </span>
                        }
                        {{ createHistoryEntryTitleIcon(event) }}
                      </mat-icon>
                    }
                    @if (event.entryType === 2) {
                      <span
                        class="fa {{ getTaskStateIcon(event.rawData.state) }}"
                        title="{{ getTaskStateIconToolTip(event.rawData.state) }}"
                      [ngStyle]="{
                        color: getTaskStateIconColor(event.rawData.state),
                      }"
                        >
                      </span>
                    }

                    @if (
                      event.entryType === 2 &&
                      event.rawData?.category &&
                      event.rawData.category.length > 0 &&
                      event.rawData.category !== "<undefiniert>"
                      ) {
                      <span> [{{ event.rawData.category }}] </span>
                    }

                    {{ createHistoryEntryTitle(event) }}
                    {{
                    event.title + (event.rawData.archived ? " (gelöscht)" : "")
                    }}

                    @if (event.entryType === 4) {
                      <span style="vertical-align: middle">
                        @if (
                          event.rawData.displayLevelMobile ===
                          NOTE_DISPLAY_LEVEL_MOBILE.Display
                          ) {
                          <mat-icon
                            class="list-icon"
                          i18n-title="
                            @@Infoportal_ElevatorDetail_NotesFacilityOverview_Cell_DisplayOnMobile"
                            title="Show note on the mobile app"
                            >smartphone
                          </mat-icon>
                          @if (
                            event.rawData.acknowledgedOnMobile ===
                            NOTE_ACK.Acknowledged
                            ) {
                            <mat-icon
                              class="list-icon"
                            i18n-title="
                              @@Infoportal_ElevatorDetail_NotesFacilityOverview_Cell_AcknowledgedOnMobile"
                              title="This note was acknowledged on the mobile app"
                              >visibility
                            </mat-icon>
                          } @else {
                            <mat-icon
                              class="list-icon transparent"
                            i18n-title="
                              @@Infoportal_ElevatorDetail_NotesFacilityOverview_Cell_NotAcknowledgedOnMobile"
                              title="This note was not yet acknowledged on the mobile app"
                              >visibility_off
                            </mat-icon>
                          }
                        } @else {
                          <span>
                            <mat-icon
                              class="list-icon"
                            i18n-title="
                              @@Infoportal_ElevatorDetail_NotesFacilityOverview_Cell_DontDisplayOnMobile"
                              title="Don't show this note on the mobile app"
                              >
                              phonelink_erase
                            </mat-icon>
                          </span>
                        }
                      </span>
                    }
                  </div>
                </ng-template>

                <ng-template cstTimelineContent let-event="event">
                  @switch (event.entryType) {
                    @case (AnlageWartungsHistoryEntryType.Contract) {
                      <ng-container
                        [ngTemplateOutlet]="contentContract"
                      [ngTemplateOutletContext]="{
                        event: event,
                        data: event.rawData,
                      }"
                        >
                      </ng-container>
                    }

                    @case (AnlageWartungsHistoryEntryType.Receipt) {
                      <ng-container
                        [ngTemplateOutlet]="contentReceipt"
                        [ngTemplateOutletContext]="{ event: event }"
                        >
                      </ng-container>
                    }

                    @case (AnlageWartungsHistoryEntryType.Task) {
                      <ng-container
                        [ngTemplateOutlet]="contentTask"
                        [ngTemplateOutletContext]="{ event: event }"
                      ></ng-container>
                    }

                    @case (AnlageWartungsHistoryEntryType.Note) {
                      <ng-container
                        [ngTemplateOutlet]="contentNote"
                        [ngTemplateOutletContext]="{ event: event }"
                        >
                      </ng-container>
                    }

                    @case (AnlageWartungsHistoryEntryType.Document) {
                      <ng-container
                        [ngTemplateOutlet]="contentDocument"
                        [ngTemplateOutletContext]="{ event: event }"
                        >
                      </ng-container>
                    }

                    @case (AnlageWartungsHistoryEntryType.Process) {
                      <ng-container
                        [ngTemplateOutlet]="contentProcess"
                        [ngTemplateOutletContext]="{ event: event }"
                        >
                      </ng-container>
                    }

                    @default {
                      <div>
                        {{ event.description }}
                      </div>
                    }
                  }
                </ng-template>
                <ng-template cstTimelineSide let-event="event">
                  <div style="text-align: right; margin-right: 20px">
                    {{ event.timestamp | date: "dd.MM.yyyy" }}
                  </div>
                </ng-template>
              </app-timeline>
            }
          </div>
        </div>
      </ng-template>

      <ng-template cstCardActions>
        <ctrl-btn
          [flat]="true"
          icon="filter_list"
        i18n-content="
          @@InfoPortal_ElevatorsDetail_WartungsHistory_BuFilter_Content"
          content="Filter"
        i18n-title="
          @@InfoPortal_ElevatorsDetail_WartungsHistory_BuFilter_Tooltip"
          title="Open the filter dialog"
          (click)="onExtendedFiltersClick()"
          [disable]="!isConnected"
        ></ctrl-btn>
        <ctrl-btn
          [flat]="true"
          icon="refresh"
        i18n-content="
          @@InfoPortal_ElevatorsDetail_WartungsHistory_BuRefresh_Content"
          content="Refresh"
        i18n-title="
          @@InfoPortal_ElevatorsDetail_WartungsHistory_BuRefresh_Tooltip"
          title="Refresh the service history"
          (click)="onSearchClick()"
          [disable]="!isConnected"
        ></ctrl-btn>
      </ng-template>
    </cst-card>
  </div>

  <ng-template #contentContract let-event="event" let-data="data">
    <p>{{ data.shortDescription }}</p>
    <table style="width: 100%">
      <tr>
        <td>
          <span i18n="@@ServiceHistory_Timeline_ContractClint">Client</span>:
        </td>
        <td>{{ data.client }}</td>
      </tr>
      <tr>
        <td>
          <span i18n="@@ServiceHistory_Timeline_ContractBeneficiary"
            >Beneficiary</span
            >:
          </td>
          <td>{{ data.beneficiary }}</td>
        </tr>
        <tr>
          <td><span i18n="@@ServiceHistory_Timeline_ContractTerm">Term</span>:</td>
          <td>{{ data.term }}</td>
        </tr>
        <tr>
          <td>
            <span i18n="@@ServiceHistory_Timeline_ContractStatus">Status</span>:
          </td>
          <td>{{ data.status }}</td>
        </tr>
        <tr>
          <td colspan="2">
            <span>{{ data.contractualObjects.length }}&nbsp;</span>
            @if (data.contractualObjects.length === 1) {
              <span i18n="@@ServiceHistory_Timeline_ContractObjectSingle"
                >Contractual Object
          </span>
            } @else {
              <span i18n="@@ServiceHistory_Timeline_ContractObjectPlural">
            Contractual Objects </span
                >:
              }
            </td>
          </tr>
          <tr>
            <td colspan="2">
              @for (obj of data.contractualObjects; track $index) {}
                <span>
                  @if ($index > 0) {
                    <span>, </span>
                  }
                  {{ obj }}
                </span>
              </td>
            </tr>
          </table>
        </ng-template>

        <ng-template #contentReceipt let-event="event">
          <div style="display: flex; flex-direction: column; align-items: flex-end">
            <table style="flex: 1 1 auto; width: 100%">
              <tr>
                <td>
                  <span i18n="@@ServiceHistory_Timeline_CustomerLabel">Customer</span>:
                </td>
                <td>{{ event.rawData.customer }}</td>
              </tr>
              <tr>
                <td><span i18n="@@ServiceHistory_Timeline_DateLabel">Date</span>:</td>
                <td>
                  {{ event.rawData.receiptDate | date: "dd.MM.yyyy" }}
                </td>
              </tr>
              <tr>
                <td>
                  <span i18n="@@ServiceHistory_Timeline_CollectiveNoLabel"
                    >CollectiveNo</span
                    >:
                  </td>
                  <td>{{ event.rawData.collectiveNr }}</td>
                </tr>
                <tr>
                  <td>
                    <span i18n="@@ServiceHistory_Timeline_ReceiptNoLabel"
                      >Receipt No.</span
                      >:
                    </td>
                    <td>{{ event.rawData.receiptNo }}</td>
                  </tr>
                  <tr>
                    <td>
                      <span i18n="@@ServiceHistory_Timeline_KeyWordLabel">KeyWord</span>:
                    </td>
                    <td>{{ event.rawData.keyword }}</td>
                  </tr>
                  <tr>
                    <td>
                      <span i18n="@@ServiceHistory_Timeline_ReceiptInfoLabel"
                        >ReceiptInfo</span
                        >:
                      </td>
                      <td>{{ event.rawData.receiptInfo }}</td>
                    </tr>
                  </table>
                  @if (clarion.isBelsoftProtocolActive$ | async) {
                    <div style="flex: 0 1 auto">
                      <ctrl-btn
                        [flat]="true"
                        title="Öffne Beleg"
                        icon="open_in_new"
                        [iconPositionRight]="true"
                        type="basic"
                        [disabled]="false || !isConnected"
                        (click)="onNavigateReceipt(event)"
                        >
                      </ctrl-btn>
                    </div>
                  }
                </div>
              </ng-template>

              <ng-template #contentTask let-event="event">
                <div style="display: flex; flex-direction: column; align-items: flex-end">
                  <table style="flex: 1 1 auto; width: 100%">
                    <tr>
                      <td>
                        <span i18n="@@ServiceHistory_Timeline_TaskNoLabel">Task No.</span>:
                      </td>
                      <td>{{ event.rawData.taskNoDisplay }}</td>
                    </tr>
                    <tr>
                      <td>
                        <span i18n="@@ServiceHistory_Timeline_Tasklabel">Tasklabel</span>:
                      </td>
                      <td>{{ event.rawData.label }}</td>
                    </tr>
                    <tr>
                      <td>
                        <span i18n="@@ServiceHistory_Timeline_Descriptionlabel"
                          >Description</span
                          >:
                        </td>
                        <td>{{ event.rawData.description }}</td>
                      </tr>
                      <tr>
                        <td>
                          <span i18n="@@ServiceHistory_Timeline_DueDatelabel">DueDate</span>:
                        </td>
                        <td>
                          {{ event.rawData.dueDate | date: "dd.MM.yyyy" }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span i18n="@@ServiceHistory_Timeline_TaskStatelabel">State</span>:
                        </td>
                        <td>{{ getTaskStateLabel(event.rawData.state) }}</td>
                      </tr>
                      <tr>
                        <td>
                          <span i18n="@@ServiceHistory_Timeline_PlannedDatelabel"
                            >Planned Date</span
                            >:
                          </td>
                          <td>
                            {{ splitDateRange(event.rawData.dateRanges, 0) }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span i18n="@@ServiceHistory_Timeline_PlannedInWeeklabel"
                              >Planned in week</span
                              >:
                            </td>
                            <td>
                              {{ splitDateRange(event.rawData.dateRanges, 1) }}
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <span i18n="@@ServiceHistory_Timeline_ToBeDonelabel"
                                >to be done in</span
                                >:
                              </td>
                              <td>
                                {{ splitDateRange(event.rawData.dateRanges, 2) }}
                              </td>
                            </tr>
                            @if (event.rawData.archived) {
                              <tr>
                                <td>
                                  <span i18n="@@ServiceHistory_Timeline_ArchivedAt">Archived at</span
                                    >:
                                  </td>
                                  <td>
                                    {{ event.rawData.archivedAtUtc }}
                                  </td>
                                </tr>
                              }
                            </table>
                            @if (this.userHasAccessToPlanungAPI === true) {
                              <div style="flex: 0 1 auto">
                                <ctrl-btn
                                  [flat]="true"
                                  title="Gehe zur Aufgabe"
                                  icon="arrow_forward"
                                  [iconPositionRight]="true"
                                  type="basic"
                                  [disabled]="false || !isConnected"
                                  [routerLink]="[event.urlToPageInWebApp]"
                                  >
                                </ctrl-btn>
                              </div>
                            }
                          </div>
                        </ng-template>

                        <ng-template #contentNote let-event="event">
                          <span>{{ event.rawData.note }}</span>
                        </ng-template>

                        <ng-template #contentDocument let-event="event">
                          @switch (event.entrySubType) {
                            @case (AnlageWartungsHistoryEntrySubType.DocumentFiling) {
                              <table style="width: 100%">
                                <tr>
                                  <td>
                                    <span i18n="@@ServiceHistory_Timeline_FileNamelabel">FileName</span
                                      >:
                                    </td>
                                    <td>{{ event.rawData.fileName }}</td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <span i18n="@@ServiceHistory_Timeline_Indiceslabel">Indices</span>:
                                    </td>
                                    <td>
                                      <table style="width: 100%">
                                        <tr>
                                          @for (i of event.rawData.indices; track i.barcodeID) {
                                            <td>{{ i.searchtext }}:</td>
                                            <td>{{ i.barcodeID }}</td>
                                          }
                                        </tr>
                                      </table>
                                    </td>
                                  </tr>
                                </table>
                              }
                              @case (AnlageWartungsHistoryEntrySubType.DocumentInfoportal) {
                                <div style="display: flex; flex-direction: column; align-items: flex-end">
                                  <table style="flex: 1 1 auto; width: 100%">
                                    <tr>
                                      <td>
                                        <span i18n="@@ServiceHistory_Timeline_Labellabel">Label</span>:
                                      </td>
                                      <td>{{ event.rawData.label }}</td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <span i18n="@@ServiceHistory_Timeline_FileNamelabel"
                                          >FileName</span
                                          >:
                                        </td>
                                        <td>{{ event.rawData.filename }}</td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <span i18n="@@ServiceHistory_Timeline_ExternalLabel"
                                            >External</span
                                            >:
                                          </td>
                                          <td>{{ event.rawData.internal !== true | yesNo }}</td>
                                        </tr>

                                        @if (event.rawData.tags?.length > 0) {
                                          <tr>
                                            <td>
                                              <span i18n="@@ServiceHistory_Timeline_Tagslabel">Tags</span>:
                                            </td>
                                            <td>
                                              <mat-chip-set class="mat-chip-set-compact">
                                                @for (tag of event.rawData.tags; track tag.label) {
                                                  <mat-chip>{{ tag.label }}</mat-chip>
                                                }
                                              </mat-chip-set>
                                            </td>
                                          </tr>
                                        }
                                      </table>
                                      <div style="flex: 0 1 auto">
                                        <ctrl-btn
                                          [flat]="true"
                                          title="Die Datei öffnen"
                                          icon="open_in_new"
                                          [iconPositionRight]="true"
                                          type="basic"
                                          [disabled]="!isConnected || !event.rawData?.filename"
            (click)="
              onInfoportalDocumentOpen(
                event.uniqueIdentifier,
                event.rawData.filename
              )
            "
                                          >
                                        </ctrl-btn>
                                      </div>
                                    </div>
                                  }
                                }
                                <!-- <div [ngSwitch]="event.entrySubType">
                                <div *ngSwitchCase="AnlageWartungsHistoryEntrySubType.DocumentFiling"></div>

                                <div
                                  *ngSwitchCase="AnlageWartungsHistoryEntrySubType.DocumentInfoportal"
                                  style="display: flex; flex-direction: column; align-items: flex-end"
                                ></div>
                              </div> -->
                            </ng-template>

                            <ng-template #contentProcess let-event="event">
                              <table style="width: 100%">
                                <tr>
                                  <td><span i18n="@@ServiceHistory_Timeline_Labellabel">Label</span>:</td>
                                  <td>{{ event.rawData.label }}</td>
                                </tr>
                                <tr>
                                  <td><span i18n="@@ServiceHistory_Timeline_Infolabel">info</span>:</td>
                                  <td>{{ event.rawData.info }}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <span i18n="@@ServiceHistory_Timeline_ExternalLabel">External</span>:
                                  </td>
                                  <td>{{ event.rawData.internal !== true | yesNo }}</td>
                                </tr>
                              </table>
                            </ng-template>
